import { FormattedMessage } from 'react-intl';

import { TextButton } from '@xing-com/button';
import { sanitizeUrl } from '@xing-com/crate-people-directory-utils';
import { IconArrowRight } from '@xing-com/icons';

import { SPECIAL_CHARACTER_ID, DATA_TEST_IDS } from './constants';
import {
  Container,
  ButtonContainer,
  ListContainer,
  StyledHeadline,
} from './user-bags.styles';

type PopularName = {
  name: string;
  url: string;
  count: number;
};

export type UserBagsProps = {
  activeLetter: string;
  popularNames: Array<PopularName>;
};

export const UserBags: React.FC<UserBagsProps> = ({
  activeLetter,
  popularNames,
}) => {
  const isSpecialCharacter = activeLetter === SPECIAL_CHARACTER_ID;

  return (
    <Container data-test-id={DATA_TEST_IDS.userBagsContainer}>
      <StyledHeadline size="large" sizeWide="medium">
        <FormattedMessage
          id={
            isSpecialCharacter
              ? 'PD_200_LASTNAMES_SPECIAL'
              : 'PD_200_LASTNAMES_MOST'
          }
          values={{ letter_variable: activeLetter.toUpperCase() }}
        />
      </StyledHeadline>
      <ListContainer>
        {popularNames.map(({ name, count, url }) => (
          <ButtonContainer key={name + url}>
            <TextButton
              size="small"
              icon={IconArrowRight}
              iconAfter
              fontWeight="regular"
              href={sanitizeUrl(url)}
              ellipsis
              data-qa={`${DATA_TEST_IDS.userBagsContainer}_${name}`}
            >
              {name} ({count})
            </TextButton>
          </ButtonContainer>
        ))}
      </ListContainer>
    </Container>
  );
};
